import { jwtDecode } from 'jwt-decode';

export const ROLES = {
  SUPERADMIN: 'superadmin',
  ADMIN: 'admin',
  TRAINER: 'trainer',
};

export const ADMIN_ROLES = [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.TRAINER];

// Every key written at login (loginPage) or on role switch (HomePage).
const SESSION_KEYS = ['accessToken', 'refreshToken', 'role', 'emailId', 'loginType'];

export const getAccessToken = () => localStorage.getItem('accessToken');

export const decodeToken = (token) => {
  if (!token) {
    return null;
  }

  try {
    return jwtDecode(token);
  } catch (error) {
    console.error('Failed to decode token:', error);
    return null;
  }
};

// `exp` is seconds since epoch. A token with no `exp` cannot be judged, so it is
// left alone here and the server stays the authority on its validity.
export const isTokenExpired = (decoded) => {
  if (!decoded || typeof decoded.exp !== 'number') {
    return false;
  }

  return decoded.exp * 1000 <= Date.now();
};

export const clearSession = () => {
  SESSION_KEYS.forEach((key) => localStorage.removeItem(key));
};

// The decoded token, but only when it is present, well-formed and unexpired.
// Anything else is "no session" — callers never have to re-check those cases.
export const getSession = () => {
  const decoded = decodeToken(getAccessToken());

  if (!decoded || isTokenExpired(decoded)) {
    return null;
  }

  return decoded;
};

export const isAuthenticated = () => getSession() !== null;

export const getRole = () => {
  const session = getSession();
  const rawRole = session?.role || localStorage.getItem('role') || localStorage.getItem('loginType') || '';
  return rawRole.toLowerCase().trim();
};

export const hasRole = (...roles) => {
  const currentRole = getRole();
  return roles.flat().map((r) => String(r).toLowerCase().trim()).includes(currentRole);
};
